<template>
    <div
    @click="openSection()"
    class="section-item"
    >
        <div class="section-image-container">
            <img :src="buttonImage" alt="button image">
        </div>
        <div class="section-text">
            {{buttonName}}
        </div>

    </div>
</template>

<script>

export default {
    name: "SectionButton",    
    props: {
        sectionItem: {},
        numberItem: Number
    },
    computed: {
        buttonImage() {
            return require(`@/assets/images/${this.sectionItem.image}`)
        },
        buttonName() {
            return this.sectionItem.sectionName
        }
    },
    methods: {
        openSection(){
            this.$emit('openSection', this.numberItem)
        }
    }
}
</script>

<style>

</style>